import React from 'react';
import { observer } from 'mobx-react-lite';
import SafeguardPageHeader from 'components/common/headers/SafeguardPageHeader';
import { EnrollmentHeaderSafeguardDelegate } from 'store/flows/enrollment/enrollmentHeaderSafeguardDelegate';
import { PageHeaderProps } from '@insurancemenu/imenu-components-lib/dist/types';

interface Props extends Omit<PageHeaderProps, 'onBackButtonClick'> {
  enrollmentHeaderSafeguardDelegate: EnrollmentHeaderSafeguardDelegate;
}

const EnrollmentSafeguardPageHeader: React.FC<Props> = observer(
  ({
    enrollmentHeaderSafeguardDelegate: { saveChangesModalDelegate, noSavingExitModalDelegate, onBackButtonStrategy },
    ...props
  }) => {
    return (
      <SafeguardPageHeader
        {...props}
        onBackButtonClick={onBackButtonStrategy}
        saveChangesModalDelegate={saveChangesModalDelegate}
        noSavingExitModalDelegate={noSavingExitModalDelegate}
      />
    );
  },
);

export default EnrollmentSafeguardPageHeader;
